import axios from 'axios'
import store from './store'
import router from './router/router'

axios.defaults.headers.common['client'] = process.env.VUE_APP_CLIENT_NAME;

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/api/v1',
});

api.interceptors.request.use(
    async (config) => {
        let token = store.state.auth.accessToken;
        if (token) {
            config.headers.authorization = 'Bearer ' + token
        }

        return config
    },
    (err) => {
        return new Promise(function () {
            const {config, request: {status}} = err;
            if (status === 401 && config) {
                store.dispatch('authLogout');
                router.push({name: 'auth.login'});
            }
            throw err;
        });
    }
);

api.interceptors.response.use(
    async (config) => {
        return config
    },
    (err) => {

        return new Promise((resolve, reject) => {

            const {config, request: {status}} = err;

            // store.state.auth.enableRefresh = true;
            if (status === 401
                && !store.state.auth.impersonateToken
                // && store.state.auth.enableRefresh
                && config) {

                // store.state.auth.enableRefresh = false;
                store.dispatch('authRefreshToken')
                    .then((resp) => {
                        // store.state.auth.enableRefresh = true;
                        router.go(router.path);
                        resolve(resp);
                    })
                    .catch((error) => {
                        store.dispatch('authLogout');
                        router.push({name: 'auth.login'});
                        reject(error)
                    });
            }

            throw err.response;

        });
    }
);


export default api
